import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import ProfileTitle from '../../../components/employerProfile/ProfileTitle';

export default class TitleView extends React.Component {
    static propTypes = {
        onEdit: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired,
    };

    render() {
        return (
            <ProfileTitle text={this.props.text}>
                <button
                    className="button button--has-icon button--pill icon icon--pencil"
                    onClick={this.props.onEdit}
                    type="button"
                >
                    <span className="u-screen-reader-only">
                        {i18n.title['edit-link']}
                    </span>
                </button>
            </ProfileTitle>
        );
    }
}
